import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../../mock";

export default function ExperienceSection() {
  return (
    <section className="relative py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.interior1} alt="Spa interior" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-charcoal/70" />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center reveal">
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="gold-rule" />
          <span className="eyebrow text-gold">Peaceful Surroundings</span>
        </div>
        <h2 className="font-display text-4xl lg:text-6xl font-light text-cream leading-tight">
          A sanctuary of calm &amp; <span className="italic text-gold">rejuvenation</span>
        </h2>
        <p className="font-sans text-cream/75 text-lg leading-relaxed mt-8">
          Experience peace and renewal in the tranquil surroundings of our luxurious spa, where attentive, individualised care is delivered with exceptional attention to every detail.
        </p>
        <Link to="/contact" className="inline-block btn-gold mt-10">Book a Treatment</Link>
      </div>
    </section>
  );
}
